"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var Exports_1 = require("./Exports");
var Context_1 = require("../Context");
var LogoHeader = /** @class */ (function (_super) {
    __extends(LogoHeader, _super);
    function LogoHeader(props) {
        return _super.call(this, props) || this;
    }
    LogoHeader.prototype.render = function () {
        return (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement(react_router_dom_1.Link, { to: "/" },
                    React.createElement("img", { src: this.props.siteLogo, alt: "VeriLite" }))),
            React.createElement("div", { className: "col-md-auto" },
                React.createElement("img", { src: this.props.companyLogo, alt: "Solidsoft Reply" })),
            React.createElement("div", { className: "col-md-auto my-auto" },
                React.createElement(Context_1.GlobalConsumer, null, function (context) { return context && (React.createElement(Exports_1.LanguageSelector, { applicationData: context })); }))));
    };
    return LogoHeader;
}(React.Component));
exports.LogoHeader = LogoHeader;
//# sourceMappingURL=LogoHeader.js.map